export const radius = {
  sm: 8,
  md: 10,
  lg: 14,
  xl: 16,
  xxl: 22,
  pill: 999,
};